import type {ProgramApiModel} from '../../../api/program';

import {currentUserStore} from '../../../api/user';

export function isMeMainCoachForProgram(program: ProgramApiModel) {
  return currentUserStore.user?._id === program.user_id;
}
